<template>
	<div>
		<v-card>
			<v-data-table
				:headers="headers"
				:items="blsSeepassData"
				:hide-default-header="$vuetify.breakpoint.xsOnly"
				item-key="id"
				class="elevation-1"
				hide-sort
				:single-expand="singleExpand"
				:expanded.sync="expanded"
				show-expand
			>
				<template v-slot:expanded-item="{ headers, item }">
					<td :colspan="headers.length">
						<div v-for="i in Object.keys(item.personalization)">
							<span>
								<span style="font-weight: bold;">{{ i }}: </span>
								<span>{{ item.personalization[i] }}</span>
							</span>
						</div>
					</td>
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'blsSeepassTable',
	props: ['blsSeepassData'],
	data() {
		return {
			expanded: [],
			singleExpand: true,
			headers: [
				{ text: 'Order Date', value: 'order_date' },
				{ text: 'Validity Start Date', value: 'validity_start_date' },
				{ text: 'Order State', value: 'order_state' },
				{ text: 'Increment ID', value: 'increment_id' },
				{ text: 'Item ID', value: 'item_id' },
				{ text: 'Order ID', value: 'order_id' },
				{ text: 'Product Name', value: 'product_name' },

				{ text: 'Buyer Salutation', value: 'buyer_salutation' },
				{ text: 'Buyer Firstname', value: 'buyer_firstname' },
				{ text: 'Buyer Lastname', value: 'buyer_lastname' },
				{ text: 'Buyer Email', value: 'buyer_email' },
				{ text: 'Buyer Telephone Number', value: 'telephone_number' },
				{ text: 'Buyer Date Of Birth', value: 'buyer_date_of_birth' },

				{ text: 'Delivery Address', value: 'billing_street' },
				{ text: 'ZIP Code', value: 'billing_zipcode' },
				{ text: 'Delivery City', value: 'billing_city' },
				{ text: 'Delivery Country', value: 'billing_country' },

				{ text: 'Seepass Donation Made?', value: 'seepass_donation_made' },
				{ text: 'Seepass Newsletter Donation Made?', value: 'seepass_newsletter_donation_made' },

				{ text: 'Additional information', value: 'data-table-expand' },
			],
		}
	},
	computed: {
	},
	methods: {
	},
}
</script>

<style scoped>

</style>
